import React, { useEffect, useState } from "react";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import PayNowButton from "../../../../components/admin/usable/actions/PayNowButton";
import toast from "react-hot-toast";
import AddButton from "../../../../components/admin/usable/AddButton";
import { makeitPaid } from "../../../../api/admin/hotel";

const MakeAPayment = ({
  item,
  setHotelData,
  Page,
  Limit,
  setPageData,
  setIsLoading,
}) => {
  const [open, setOpen] = useState(false);
  const [PaidAmount, setPaidAmount] = useState("");
  const [fieldError, setFieldError] = useState(false);

  useEffect(() => {
    const totalAmount =
      item.discountedAmount + item.taxAmount - item.paidAmount;
    if (PaidAmount > totalAmount) {
      setFieldError(true);
    } else {
      setFieldError(false);
    }
  }, [PaidAmount]);
  const handleMakePaid = () => {
    makeitPaid(
      item.invoiceId,
      PaidAmount,
      setHotelData,
      Page,
      Limit,
      setPageData,
      setIsLoading,
    );
  };
  return (
    <>
      <PayNowButton onClick={() => setOpen(true)} />
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{ maxWidth: 500, borderRadius: "md", p: 3, boxShadow: "lg" }}
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            sx={{ fontWeight: "lg", mb: 1 }}
          >
            {item.invoiceId}
          </Typography>
          <div className="space-y-3">
            <div>
              <p className="text-xs text-center">
                <strong>The payment requirements are</strong> : 1) You can take
                full payment but can not greater than total amount 2) You can
                take advance payment set on the system of a hotel 3) Once
                payment you can not reverse.
              </p>
            </div>
            <div className="space-y-3">
              <p>
                <strong>Total Amount:</strong> {item.discountedAmount || 0} BDT
              </p>
              <p>
                <strong>Total Service Charge:</strong> {item.taxAmount || 0} BDT
              </p>
              <p>
                <strong>Total Paid Amount:</strong> {item.paidAmount || 0} BDT
              </p>
              <p>
                <input
                  type="number"
                  className={`w-full border ${fieldError ? "border-red-500" : ""} rounded-md focus:outline-none px-2 py-1`}
                  placeholder={`Need to pay: ${(item.discountedAmount + item.taxAmount - item.paidAmount).toFixed(0)} BDT`}
                  onChange={(e) => setPaidAmount(e.target.value)}
                  value={PaidAmount}
                />
              </p>
            </div>
            <div className="flex justify-end pt-3">
              <AddButton onClick={handleMakePaid} text={"Pay Now"} />
            </div>
          </div>
        </Sheet>
      </Modal>
    </>
  );
};

export default MakeAPayment;
